/* Scoped custom element also initializes cards inserted by filters/recommendations. */
if (!customElements.get('card-color-swatches')) {
  customElements.define('card-color-swatches', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.card = this.closest('.card');
      this.image = this.card?.querySelector('.card__media .media > img');
      const options = { signal: this.controller.signal };
      this.addEventListener('pointerover', (event) => {
        if (event.pointerType !== 'mouse' || !matchMedia('(min-width: 750px) and (hover: hover) and (pointer: fine)').matches) return;
        this.preview(event.target.closest('a[data-preview-src]'));
      }, options);
      this.addEventListener('pointerout', (event) => {
        if (event.pointerType === 'mouse' && !this.contains(event.relatedTarget)) this.restore();
        else if (event.pointerType === 'mouse' && !event.relatedTarget?.closest?.('a[data-preview-src]')) this.restore();
      }, options);
      this.addEventListener('focusin', (event) => this.preview(event.target.closest('a[data-preview-src]')), options);
      this.addEventListener('focusout', () => this.restore(), options);
      // A missing color image should leave the original card photograph visible.
      this.image?.addEventListener('error', () => this.restore(), options);
    }
    preview(link) {
      if (!link || !this.image) { this.restore(); return; }
      if (!this.original) {
        this.original = Object.fromEntries(['src', 'srcset', 'sizes', 'alt'].map((name) => [name, this.image.getAttribute(name)]));
      }
      this.image.removeAttribute('srcset');
      this.image.removeAttribute('sizes');
      this.image.src = link.dataset.previewSrc;
      this.image.alt = link.dataset.previewAlt;
      this.card.classList.add('card-color-swatches--previewing');
    }
    restore() {
      if (!this.original || !this.image) return;
      for (const [name, value] of Object.entries(this.original)) {
        if (value === null) this.image.removeAttribute(name);
        else this.image.setAttribute(name, value);
      }
      this.original = null;
      this.card.classList.remove('card-color-swatches--previewing');
    }
    disconnectedCallback() {
      this.restore();
      this.controller?.abort();
      this.controller = null;
    }
  });
}
